import type { HeaderData } from '@/shared/ui/organisms/Header/header';

export const headerMock: HeaderData = {
    logo: {
        src: '/assets/logo/wihe_logo.png',
        alt: 'My Logo',
        width: 40,
        height: 40,
        text: 'Mykola',
    },
    nav: [
        { name: 'Home', href: '#home' },
        { name: 'About', href: '#about' },
        { name: 'Services', href: '#services' },
        { name: 'Projects', href: '#projects' },
        { name: 'Experience', href: '#experience' },
    ],
    error: null,
};
